/**
 * Input/output for the `sendSupportRequest` callable. Takes a user-authored
 * subject + message and emails the support inbox via the same Trigger Email
 * pipeline as every other system email. Reply-To is set to the caller's auth
 * email so support can hit Reply and reach the user directly.
 */

import { z } from 'zod';

export const sendSupportRequestInputSchema = z
  .object({
    /** Optional. Defaults to "Support request from {email}" if omitted. */
    subject: z.string().optional(),
    /** Required. The body of the support request. Trimmed server-side. */
    message: z.string().min(1),
    /** Optional context — the URL the user was on when they submitted. */
    url: z.string().optional(),
    /**
     * Optional event context. When set, the server prefixes the email body with
     * the event name and the caller's per-event role so the operator can triage
     * mobile support requests against the right event.
     */
    eventId: z.string().optional(),
  })
  .strict();

export type SendSupportRequestInput = z.infer<
  typeof sendSupportRequestInputSchema
>;

export interface SendSupportRequestResponse {
  success: true;
}
